import { CommonModule } from "@angular/common";
import { Component, Inject, OnInit } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTooltipModule } from "@angular/material/tooltip";
import { Form10AInformation } from "app/api/models";
import { Form10AService } from "app/api/services";
import { DLMSharedModule } from "app/views/calibrations/shared/shared.module";
import { DragScrollModule } from "ngx-drag-scroll";
import { NgxPrintModule } from "ngx-print";

@Component({
  selector: "app-select-for-bulk-qr-dialog",
  templateUrl: "./select-for-bulk-qr-dialog.component.html",
  styleUrls: ["./select-for-bulk-qr-dialog.component.scss", "./../../../../_styles/calibration-overrides.scss"],
  standalone: true,
  imports: [
    CommonModule,
    DLMSharedModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatInputModule,
    MatMenuModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    FlexLayoutModule,
    DragScrollModule,
    NgxPrintModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatRadioModule,
  ]
})
export class SelectForBulkQrDialogComponent implements OnInit {
  public loadcells: number[];
  public form10as: Form10AInformation[];

  public includedLoadcellIds: number[] = [];

  constructor(
    public dialogRef: MatDialogRef<SelectForBulkQrDialogComponent>,
    public form10aService: Form10AService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.data != null) {
      this.form10aService
        .apiForm10AForm10ALoadcellsInGroupGet$Json$Response({ loadcellId: this.data.loadcellId })
        .subscribe((res) => {
          if (!res?.body?.data) return;

          //show tickboxes
          console.log("form10as in group", res.body.data);

          this.includedLoadcellIds.push(this.data?.loadcellId);
          this.loadcells = res.body.data.map((x) => x.loadcellId);
          this.form10as = res.body.data;
        });
    }
  }

  toggleIncludeCell(cell: number, $event: any) {
    if ($event.checked) {
      this.includedLoadcellIds?.push(cell);
    } else {
      this.includedLoadcellIds?.splice(
        this.includedLoadcellIds?.findIndex((x) => x == cell)
      );
    }
  }

  getBookingRefOfLoadcell(cell: number) {
    return this.form10as?.find((x) => x.loadcellId == cell)?.bookingRef;
  }

  isIncluded(cell: number) {
    return this.includedLoadcellIds?.includes(cell);
  }

  close(returnData: boolean) {
    this.dialogRef.close(
      returnData
        ? this.form10as.filter((x) =>
            this.includedLoadcellIds.includes(x.loadcellId)
          )
        : null
    );
  }
}
